import _ from 'underscore';

// TODO: add theme as second paramater when available
export const doubleListBoxStyles = ({ doubleListBoxView = {} }, { semanticColors = {} }) => {
  const defaultDoubleListBox = {
    width: '905px',
    marginLeft: '4px',
    paddingLeft: 10,
    paddingBottom: 10,
    '& .selected': {
      'margin-left': '10px',
    },
  };

  const defaultListBoxContainer = {
    border: {
      color: '#606060',
      style: 'solid',
      width: 1,
    },
    height: 450,
    margin: 'auto',

    '& .button-add-remove': {
      border: 'none',
      color: '#1570A6',
      'font-size': 12,
      'font-weight': 'normal',
    },

    '& .btn-default': {
      border: 'none',
      background: 'rgba(0, 0, 0, 0.0)',
    },
  };

  const defaultListBoxHeader = {
    'background-color': '#f2f2f2',
    'font-weight': 'bold',
    height: 45,

    '& Label': {
      'word-wrap': 'break-word',
      'line-height': '45px',
      'margin-left': '10px',
    },
  };

  const defaultListBoxContent = {
    height: 400,
    'overflow-y': 'scroll',
    'overflow-x': 'hidden',

    '& .search-box': {
      display: 'inline-block',
      width: '100%',
      margin: {
        top: '7.5px',
        bottom: '7.5px',
      },

      '& .input': {
        width: '95%',
        float: 'left',
        'margin-right': '7.5px',
      },

      '& .icon': {
        'line-height': '25px',
      },
    },
  };

  const defaultSourceCategories = {
    width: '100%',

    '& .btn.btn-default:disabled': {
      color: '#666666',
      border: 'none',
    },
  };

  const defaultSourceCategoriesSearchResults = {
    width: '100%',

    '& .category-name': {
      'font-size': 12,
      'font-weight': 'bold',
      'margin-top': 10,
    },

    '& .button-action': {
      border: 'none',
    },

    '& .item': {
      height: 30,
      'line-height': '25px',
      'margin-top': '5px',
    },
  };

  const defaultSourceCategory = {
    border: 'none',
    'margin-top': 10,
    'font-size': 12,

    '& .container-fluid': {
      'padding-bottom': '5px',

      '& .category-title': {
        float: 'left',
        'line-height': '15px',
      },

      '& .category-description': {
        'text-align': 'left',
        'font-weight': 'normal',
        'white-space': 'normal',
        'margin-top': '20px',
      },

      '& .category-action': {
        'margin-top': '20px',
      },
    },
  };

  const defaultSourceListBox = {
    width: '100%',

    '& .button-add-remove': {
      border: 'none',
    },

    '& .button-action': {
      border: 'none',
    },

    '& .source-list-box-header': {
      'line-height': '25px',
      'margin-top': '5px',
      'border-bottom': {
        style: 'solid',
        color: '#404040',
        width: '1px',
      },
    },

    '& .item': {
      height: 30,
      'line-height': '25px',
      'margin-top': '5px',

      '& div:disabled': {
        color: '#666666',
      },
    },
  };

  const defaultSelectedListBoxGroup = {
    '& .selected-list-box-header': {
      'line-height': '25px',
      'margin-top': '5px',
      'border-bottom': {
        style: 'solid',
        color: '#404040',
        width: '1px',
      },
    },

    '& .category-name-button': {
      'margin-bottom': '2px',
    },

    '& .item': {
      height: 30,
      'line-height': '25px',
      'margin-top': '5px',
      'background-color': '#e7f0f6',
      border: {
        color: '#1570a6',
        style: 'solid',
        width: '1px',
      },
    },

    '& .unavailable-item': {
      color: semanticColors.errorIcon || '#A80000',
    },
  };

  const defaultSelectedListBox = {
    width: '100%',
    '& .selected-remove': {
      border: 'none',
    },

    '& .button-action': {
      border: 'none',
      'background-color': '#e7f0f6',
    },

    '& .category-name': {
      'font-size': 12,
      'font-weight': 'bold',
      'margin-top': 10,
    },

    '& .category-name-button': {
      border: 'none',
    },

    '& .collapsed': {
      visibility: 'hidden',
      display: 'none',
    },
  };

  const defaultButtonAddRemove = {};

  const defaultButtonBack = {
    border: 'none',
    'background-color': '#f2f2f2',
    'padding-left': 0,
    'padding-right': 0,
    'min-width': 30,
  };

  return {
    doubleListBox: _.extend(
      defaultDoubleListBox,
      doubleListBoxView.doubleListBox
    ),
    listBoxContainer: _.extend(
      defaultListBoxContainer,
      doubleListBoxView.listBoxContainer
    ),
    listBoxHeader: _.extend(
      defaultListBoxHeader,
      doubleListBoxView.listBoxHeader
    ),
    listBoxContent: _.extend(
      defaultListBoxContent,
      doubleListBoxView.listBoxContent
    ),
    sourceCategories: _.extend(
      defaultSourceCategories,
      doubleListBoxView.sourceCategories
    ),
    sourceCategoriesSearchResults: _.extend(
      defaultSourceCategoriesSearchResults,
      doubleListBoxView.sourceCategoriesSearchResults
    ),
    sourceCategory: _.extend(
      defaultSourceCategory,
      doubleListBoxView.sourceCategory
    ),
    sourceListBox: _.extend(
      defaultSourceListBox,
      doubleListBoxView.sourceListBox
    ),
    selectedListBoxGroup: _.extend(
      defaultSelectedListBoxGroup,
      doubleListBoxView.selectedListBoxGroup
    ),
    selectedListBox: _.extend(
      defaultSelectedListBox,
      doubleListBoxView.selectedListBox
    ),
    buttonAddRemove: _.extend(
      defaultButtonAddRemove,
      doubleListBoxView.buttonAddRemove
    ),
    buttonBack: _.extend(
      defaultButtonBack,
      doubleListBoxView.buttonBack
    ),
  };
};
